import { ReactElement } from 'react'
import SimplifiedSeismicSettings from './components/SimplifiedSeismicTab'

/**
 * Seismic loads tab. The simplified substitute-force method is the only
 * procedure offered here, so the tab renders it directly.
 */
const SeismicSettingsTab = (): ReactElement => <SimplifiedSeismicSettings />

export default SeismicSettingsTab
